var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 5.5,
    stroke: "#5A5A5A",
    strokeOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0311 22.5C18.3011 22.5 17.4822 22.3595 16.6239 22.0886C14.562 21.4365 12.5297 20.0719 10.9019 18.2459C8.46506 15.5068 7.30092 12.7777 7.52782 10.3497C7.59688 9.74769 7.78433 8.98516 8.67223 8.37312C9.35296 7.81126 10.1323 7.4902 10.744 7.50023C11.3853 7.51026 11.6023 7.74103 12.2633 8.71426C13.2795 10.139 13.3485 10.8413 13.3091 11.2426C13.24 11.9048 12.8848 12.1958 12.5593 12.4567C12.4804 12.5169 12.4014 12.5871 12.3324 12.6473C11.9377 13.159 11.4543 13.8714 13.5261 16.0486C15.2921 17.7743 16.249 17.985 16.6535 17.9549C16.9692 17.9349 17.0876 17.7643 17.1369 17.7041L17.1468 17.6941C17.8078 16.7509 18.0248 16.5202 18.6562 16.4198C19.2679 16.3195 19.5836 16.5202 20.8858 17.3529C22.0599 18.1054 22.6025 18.6071 22.4841 19.3997C22.4446 20.2626 21.7935 21.4365 21.0634 21.9682C20.5603 22.3194 19.8598 22.5 19.0311 22.5Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone2);
export default __webpack_public_path__ + "static/media/icon_phone_2.e82c8120a4abaae024c59dd9f8cd5024.svg";
export { ForwardRef as ReactComponent };